import React, { useRef, useEffect } from 'react';

function StarryNight() {
  const canvasRef = useRef(null);
  const starsRef = useRef([]);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');

    // Fill the entire screen
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    // Reduce the number of stars for a subtle effect
    const numStars = 80;

    function initStars() {
      let tempStars = [];
      for (let i = 0; i < numStars; i++) {
        tempStars.push({
          x: Math.random() * canvas.width,
          y: Math.random() * canvas.height,
          // Smaller star radius
          radius: Math.random() * 1 + 0.3,
          // Slower falling speed
          velocity: Math.random() * 0.1 + 0.05,
        });
      }
      starsRef.current = tempStars;
    }

    initStars();

    function animate() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // Plain black background
      ctx.fillStyle = '#000';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      starsRef.current.forEach((star) => {
        // Move the star
        star.y += star.velocity;

        // If it goes off screen, reset it to the top
        if (star.y > canvas.height) {
          star.y = 0;
          star.x = Math.random() * canvas.width;
        }

        // Draw each star with a slight transparency
        ctx.beginPath();
        ctx.arc(star.x, star.y, star.radius, 0, 2 * Math.PI);
        ctx.fillStyle = 'rgba(255, 255, 255, 0.6)';
        ctx.fill();
      });

      requestAnimationFrame(animate);
    }

    animate();

    // Handle resizing
    const handleResize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      initStars();
    };
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: -1,       // Ensures the canvas is behind other elements
        backgroundColor: '#000',
      }}
    />
  );
}

export default StarryNight;